<div style="position: relative;">
    <h3 class="mat-form-field-label-wrapper label-style">{{ props.label }}<span *ngIf="props.required">*</span></h3>
    <ng-container #fieldComponent></ng-container>

    <div class="mat-form-field-hint-wrapper ">
        <mat-hint *ngIf="isHtml" [innerHtml]="props.description"></mat-hint>
        <mat-hint *ngIf="!isHtml" [innerText]="props.description"></mat-hint>
    </div>
</div>